import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AssignCoachCompanyRequest = {
  tripBookingId: number
  centerId: number
  arrivalCoachCompanyId?: number
  departureCoachCompanyId?: number
}

export async function assignCoachCompany(input: AssignCoachCompanyRequest) {
  const { centerId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.centers.assignCoachCompany.url, { id: centerId }))
    .post(rest)
}
